import React from "react";
import cn from 'classnames';
import Image from '@base/lib/ThemeImage';
import { IFeatureNavigation, INavigation } from 'mod/feature/interface';
import Tracker from '@base/lib/Tracker';
import homeStyles from '@app/shop/index.module.less';
import Link from '@base/lib/ThemeLink';
import { splitGroups } from 'base/utils/arr';
import titleStyles from 'app/styles/modules/title.module.less';
import FeatureSwiper from 'components/shop/FeatureSwiper';
import styles from "./index.module.less"
import { getModuleCode, getModuleElementId, getWrapStyle } from 'base/utils/features';

declare type IProps = {
    data: IFeatureNavigation;
}

const Navigation: React.FC<IProps> = ({ data }) => {
    if (!data.lists.length) {
        return null;
    }
    const groupedData = { ...data, lists: splitGroups(data.lists, 2) }
    const moduleElementId = getModuleElementId(data);
    const moduleCode = getModuleCode(data);

    return (
        <FeatureSwiper
            id={moduleElementId}
            data-t-mod={moduleCode}
            className={homeStyles.wrapper}
            style={getWrapStyle(data)}
            title={{ className: cn(titleStyles.title, homeStyles.title) }}
            data={groupedData}
            swiper={{
                className: homeStyles.swiper,
                slidesPerGroup: 1,
                slidesPerView: 'auto',
                slidesPerGroupAuto: true,
                spaceBetween: 20,
                pagination: false,
                render: (group: INavigation[], slideIndex)=>(
                    <>
                        {group.map((item, index) => (
                            <Tracker
                                key={item.title + index}
                                data={{
                                    targetType: 'menu',
                                    target: item.linkUrl,
                                    relTarget: item.linkUrl,
                                    module: moduleCode,
                                    position: `${(index + 1)}.${slideIndex + 1}`,
                                    creative: item.picUrl,
                                }}
                            >
                                <div className={styles.item}>
                                    <Link href={item.linkUrl}>
                                        <a className={styles.link}>
                                            <div className={styles.img}>
                                                <Image
                                                    src={item.picUrl}
                                                    alt={item.title}
                                                    width={80}
                                                    background={false}
                                                />
                                            </div>

                                            <div className={styles.title}>
                                                {item.title}
                                            </div>
                                        </a>
                                    </Link>
                                </div>
                            </Tracker>
                        ))}
                    </>
                )
            }}
        />
    )
}

export default React.memo(Navigation)